import api from "./api";

export async function fetchProfileSettingsProfile() {
  const response = await api.get("/profile-settings/profile");
  return response?.data?.dataset?.data?.user ?? null;
}

export async function updateProfileSettingsProfile(payload) {
  const isFormDataPayload = typeof FormData !== "undefined" && payload instanceof FormData;
  const response = await api.post(
    "/profile-settings/profile",
    payload,
    isFormDataPayload
      ? {
          headers: {
            "Content-Type": undefined,
          },
        }
      : undefined
  );
  return {
    payload: response?.data?.dataset?.data ?? null,
    meta: response?.data || {},
  };
}
